export const useStyles = (theme) => ({
  root: { display: "flex", alignItems: "center" },
  tooltip: { "&:hover": { cursor: "pointer" } },
});
